import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Checkbox, Input } from "antd";

import * as Common from "../commons/common";
import * as Types from "../commons/typeDTO";

import moment from "moment";
import SearchDate from "./SearchDate";
import SelectRentCar from "./SelectRentCar";

export type RentAdminReservation = {
    rentCarId: number;
    name: string;
    phone: string;
    startDate: string;
    endDate: string;
};

function ModalAdminReservation({
    open,
    onChangedOpen,
    onChangeRentInfo,
}: {
    open: boolean;
    onChangedOpen: (open: boolean) => void;
    onChangeRentInfo?: (rentInfo: RentAdminReservation) => void;
}) {
    const [form] = Form.useForm();

    const [searchStartDate, setSearchStartDate] = useState(moment().format(Common.FORMAT_DATE));
    const [searchEndDate, setSearchEndDate] = useState(moment().add(1, "days").format(Common.FORMAT_DATE));
    const [rentCar, setRentCar] = useState<Types.RentCarDto | undefined>();
    const [checkUserAlpamotors, setCheckUserAlpamotors] = useState(true);
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");

    useEffect(() => {
        form.resetFields();
    }, [open]);

    const handleClose = () => {
        onChangedOpen(false);
    };

    const onFinish = (values: any) => {
        onChangedOpen(false);

        if (rentCar !== undefined && name !== null && name.length > 0 && phone !== null && phone.length > 0) {
            const rentInfo: RentAdminReservation = {
                rentCarId: rentCar.rentCarId,
                name: name,
                phone: phone,
                startDate: searchStartDate,
                endDate: searchEndDate,
            };

            onChangeRentInfo && onChangeRentInfo(rentInfo);
        }
    };

    const onChangedSearchDate = (type: string, value: string) => {
        if (type === "startDate") setSearchStartDate(moment(value).format(Common.FORMAT_DATE));
        else if (type === "endDate") setSearchEndDate(moment(value).format(Common.FORMAT_DATE));
    };

    const onChangeRentCarInfo = (rentCar: Types.RentCarDto) => {
        setRentCar(rentCar);
    };

    useEffect(() => {
        if (checkUserAlpamotors) {
            setName("알파모터스");
            setPhone("01026800510");
        } else {
            setName("");
            setPhone("");
        }
    }, [checkUserAlpamotors]);

    return (
        <Modal
            centered
            forceRender
            closable={false}
            className="login"
            open={open}
            title="관리자 예약"
            onOk={handleClose}
            onCancel={handleClose}
            footer={[
                <Button key="back" onClick={handleClose}>
                    취소
                </Button>,
                <Button key="setPassword" type="primary" onClick={() => form.submit()}>
                    추가
                </Button>,
            ]}
        >
            <Form form={form} onFinish={onFinish} layout="vertical">
                <Form.Item name="date" label="예약일자">
                    <SearchDate startDate={searchStartDate} endDate={searchEndDate} onSearch={onChangedSearchDate} />
                </Form.Item>
                <Form.Item name="rentCar" label="예약차량">
                    <SelectRentCar showTitle={true} onChangeInfo={onChangeRentCarInfo} />
                </Form.Item>
                <Form.Item label="예약자">
                    <Checkbox checked={checkUserAlpamotors} onChange={(e) => setCheckUserAlpamotors(e.target.checked)}>
                        알파모터스
                    </Checkbox>
                    <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="이름"></Input>
                    <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="전화번호"></Input>
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default ModalAdminReservation;
